import { type ICallAccount } from '@/types/ICallAccount';

/**
 * Формирует имя клиента звонка в порядке «Имя Фамилия» — как в тексте тикета.
 * Отличается от `formatClientFullName` («Фамилия Имя») порядком частей и тем,
 * что работает с `ICallAccount`, где обе части опциональны.
 *
 * @param account - аккаунт из payload звонка
 * @returns строка «Имя Фамилия» либо пустая строка, если имени нет
 */
export const formatCallAccountName = (
  account: ICallAccount | null
): string => {
  if (account === null) {
    return '';
  }

  return [account.name, account.surname]
    .filter(
      (part): part is string => typeof part === 'string' && part.trim() !== ''
    )
    .map((part) => part.trim())
    .join(' ');
};
